import {chat,version,timeline,view_latest_design,view_ad_detauls} from "../../../assets/svg"

export const createActionHandlers = (setState) => {
    const setModal = setState.setModal;
    const setDrawer = setState.setDrawer;
    const setExpandedVersionsRow = setState.setExpandedVersionsRow;
    const setShowActionsMenu = setState.setShowActionsMenu;

    return {
        viewLatestDesign: (row) => {
            setExpandedVersionsRow(null);
            setShowActionsMenu(-1);
            setModal({
                open: true,
                type: 'latestDesign',
                image: row.latest_design 
            });
        },

        openChat: (row) => {
            setExpandedVersionsRow(null);
            setShowActionsMenu(-1);
            setDrawer({
                open: true,
                type: 'chat',
                rowData: row
            });
        },

        viewTimeline: (row) => {
            setExpandedVersionsRow(null);
            setShowActionsMenu(-1);
            setModal({
                open: true,
                type: 'timeline',
                timelineData: row || null
            });
        },

        viewAdDetails: (row) => {
            setExpandedVersionsRow(null);
            setShowActionsMenu(-1);
            setDrawer({
                open: true,
                type: 'adDetails',
                rowData: row
            });
        },

        toggleVersions: (rowIndex, currentExpanded) => {
            setExpandedVersionsRow(currentExpanded === rowIndex ? null : rowIndex);
        },

        toggleActionsMenu: (rowIndex, currentShow) => {
            setShowActionsMenu(currentShow === rowIndex ? -1 : rowIndex);
        },

        closeModal: () => {
            setModal({ open: false, type: null, image: null, timelineData: null });
        },

        closeDrawer: () => {
            setDrawer({ open: false, type: null, rowData: null });
        }
    };
};

export const ACTION_CONFIGS = [
    {
        key: 'viewLatestDesign',
        icon: view_latest_design,
        alt: 'View Latest Design',
        tooltip: 'View Latest Design'
    },
    {
        key: 'openChat',
        icon: chat,
        alt: 'Chat',
        tooltip: 'Actions'
    },
    {
        key: 'toggleVersions',
        icon: version,
        alt: 'Versions',
        tooltip: 'Versions'
    },
    {
        key: 'viewTimeline',
        icon: timeline,
        alt: 'Timeline',
        tooltip: 'Timeline'
    },
    {
        key: 'viewAdDetails',
        icon: view_ad_detauls,
        alt: 'View Ad Details',
        tooltip: 'View Ad Details'
    }
]; 